import { sCurrencyFormatter, sBanner, sBannerStep } from '../../shared.min.js';

import { sharedElements } from '../shared-mileage-fuelcost/elements/elements.min.js';

import { PriceStatistics } from '../shared-mileage-fuelcost/shared-functions/price-statistics.min.js';
import { VehicleDetails } from '../shared-mileage-fuelcost/shared-functions/vehicle-details.min.js';
import { AnnualMileageCalculation } from '../shared-mileage-fuelcost/shared-functions/annual-mileage.min.js';
import { ResetCalculator } from '../shared-mileage-fuelcost/shared-functions/reset-calculator.min.js';

import { checkSelectedFuelTypeHelper } from '../shared-mileage-fuelcost/helpers/selected-fuel-helper.min.js';

import {
	vehicleDetailsConfig,
	priceStatisticsConfig,
	mileageCalculationConfig,
	resetCalculatorConfig,
} from '../shared-mileage-fuelcost/config/annual-config.min.js';

const fuelCostCalculator = {
	cmsContent: {},
	pageElements: {},
	isDevMode: false,
	vehicleDetails: {},
	annualMileageInstance: null,
	bannerInstance: null,
	fuelPrices: {},

	singleTripContent: {
		singleResults: document.getElementById('fcc-singleTripViewResults'),
		singleForm: document.getElementById('fcc-singleTripView'),
		singleFormTripFrom: document.getElementById('fcc-singleTripFrom'),
		singleFormTripTo: document.getElementById('fcc-singleTripTo'),
		singleFormTripSearchBtn: document.getElementById('cnfsd_fcc-singleViewCalc'),
		singleTripRegistration: document.getElementById('fcc-singleTripRegistration'),
		singleTripFuelType: document.getElementById('fcc-singleTripFuelType'),
		singleTripMilesTitle: document.getElementById('fcc-singleTripMiles'),
		singleTripPrice: document.getElementById('fcc-singleTripPrice'),
		singleTripMPG: document.getElementById('fcc-singleTripMPG'),
		singleTripPostcodeFrom: document.getElementById('fcc-singleTripPostcodeFrom'),
		singleTripPostcodeTo: document.getElementById('fcc-singleTripPostcodeTo'),
		singleTripCost: document.getElementById('fcc-singleTripCost'),
		singleTripRadio: document.getElementById('fcc-singleTrip'),
		annualTripRadio: document.getElementById('fcc-annual'),
		fccRegistrationError: document.getElementById('fcc-registration-error'),
		fccRegistrationErrorMessage: document.getElementById('fcc-registration-error-message'),
		fccSingleTripViewErrorMessage: document.getElementById('fcc-singleTripViewErrorMessage'),
		distanceText: null,
		annualRadioButton: document.getElementById('fcc-annual'),
		restartButton: document.getElementById('start-again-button'),
	},

	init() {
		// Grab CMS content and page elements once
		this.cmsContent = sharedElements.getCMSContent('fcc', this.isDevMode);
		this.pageElements = sharedElements.getPageElements('fcc');

		if (this.cmsContent.resultText)
			this.singleTripContent.distanceText =
				this.cmsContent.resultText.getAttribute('data-distance-text') || 'miles';

		this.getPriceStatistics();

		this.setUpContinueButton();

		this.setUpBanner();

		this.setUpLiveUpdateInputs();

		//single trip setup

		this.setUpSingleTripSearchButton();

		this.setUpTripTypeToggle();

		this.setUpRestartButton();
	},

	setUpSingleTripSearchButton: function () {
		this.singleTripContent.singleFormTripSearchBtn.addEventListener('click', async e => {
			e.preventDefault();

			try {
				const distance = await this.singleTripDistanceCalculation(
					this.singleTripContent.singleFormTripFrom,
					this.singleTripContent.singleFormTripTo
				);

				const price = this.handleSingleMileageCalculation(distance);
				if (price) this.updateSingleTripUI(distance, price);
			} catch (error) {
				console.error('Error during distance calculation:', error);
				this.singleTripContent.fccSingleTripViewErrorMessage.textContent =
					'Unable to calculate distance. Please check your input and try again.';
			}
		});
	},

	setUpBanner: function () {
		sBanner(
			this.pageElements.calc,
			[this.cmsContent.bannerStep1Text, this.cmsContent.bannerStep2Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);
	},

	getPriceStatistics: async function () {
		const config = priceStatisticsConfig({
			pageElements: fuelCostCalculator.pageElements,
			cmsContent: fuelCostCalculator.cmsContent,
			selectedFuelType: checkSelectedFuelTypeHelper(fuelCostCalculator.pageElements.fuelTypeRadioGroup),
		});

		const priceStatistics = new PriceStatistics(config);
		this.fuelPrices = await priceStatistics.getPriceStatistics();
	},

	handleAnnualMileageCalculation: function () {
		const config = mileageCalculationConfig({
			pageElements: fuelCostCalculator.pageElements,
			cmsContent: fuelCostCalculator.cmsContent,
			vehicleMPG: this.vehicleDetails.vehicleMPG,
		});

		this.annualMileageInstance = new AnnualMileageCalculation(config);
		this.annualMileageInstance.handleMileageCalculation();
	},

	setUpContinueButton: function () {
		const config = vehicleDetailsConfig({
			pageElements: fuelCostCalculator.pageElements,
			cmsContent: fuelCostCalculator.cmsContent,
			selectedFuelType: checkSelectedFuelTypeHelper(fuelCostCalculator.pageElements.fuelTypeRadioGroup),
		});

		const vehicleDetails = new VehicleDetails(config, this.bannerInstance);

		this.pageElements.continueButton.addEventListener('click', async e => {
			e.preventDefault();

			this.vehicleDetails = await vehicleDetails.handleContinuePressed();
			this.handleAnnualMileageCalculation();
			sBannerStep(2);
		});
	},

	setUpLiveUpdateInputs: function () {
		[this.pageElements.annualMileage, this.pageElements.fuelCostInput].forEach(input => {
			input.addEventListener('input', () => {
				if (this.vehicleDetails.vehicleMPG === 0) return;

				this.annualMileageInstance.handleMileageCalculation();
			});
		});

		//single trip
		this.singleTripContent.singleFormTripFrom.addEventListener('input', () => this.checkSingleTripInputs());
		this.singleTripContent.singleFormTripTo.addEventListener('input', () => this.checkSingleTripInputs());
	},

	setUpTripTypeToggle: function () {
		const { singleTripRadio, annualTripRadio } = this.singleTripContent;

		singleTripRadio.addEventListener('change', () => {
			if (singleTripRadio.checked) {
				this.singleTripContent.singleForm.classList.remove('display-none');
				this.singleTripContent.singleResults.classList.add('display-none');
				this.pageElements.annualForm.classList.add('display-none');
				this.pageElements.annualResults.classList.add('display-none');
				this.singleTripContent.singleFormTripSearchBtn.classList.remove('display-none');
			}
		});

		annualTripRadio.addEventListener('change', () => {
			if (annualTripRadio.checked) {
				this.singleTripContent.singleForm.classList.add('display-none');
				this.singleTripContent.singleResults.classList.add('display-none');
				this.pageElements.annualForm.classList.remove('display-none');
				this.pageElements.annualResults.classList.remove('display-none');
				this.singleTripContent.singleFormTripSearchBtn.classList.add('display-none');
			}
		});
	},

	checkSingleTripInputs: function () {
		const fromInput = this.singleTripContent.singleFormTripFrom.value;
		const toInput = this.singleTripContent.singleFormTripTo.value;

		const postcodeRegex = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i;

		// Check if both inputs are valid postcodes
		if (postcodeRegex.test(fromInput) && postcodeRegex.test(toInput)) {
			this.singleTripContent.singleFormTripSearchBtn.classList.remove('display-none');
		} else {
			this.singleTripContent.singleFormTripSearchBtn.classList.add('display-none');
		}
	},

	formatPostcodeHelper(postcode) {
		return postcode.toUpperCase().replace(/^(.{4})(.{3})$/, '$1 $2');
	},

	updateSingleTripUI: function (distance, price) {
		const {
			singleTripRegistration,
			singleTripFuelType,
			singleTripMilesTitle,
			singleTripPrice,
			singleTripMPG,
			singleTripPostcodeFrom,
			singleTripPostcodeTo,
			singleResults,
			distanceText,
			singleFormTripFrom,
			singleFormTripTo,
			singleTripCost,
			singleFormTripSearchBtn,
		} = this.singleTripContent;

		const fuelTypeSelectedValue = checkSelectedFuelTypeHelper(this.pageElements.fuelTypeRadioGroup);
		const fuelTypeSelected =
			fuelTypeSelectedValue === '2' ? this.cmsContent.fuelTypePetrol : this.cmsContent.fuelTypeDiesel;
		const fuelTypeSelectedText = `${fuelTypeSelected} ${this.vehicleDetails.vehicleMake} ${this.vehicleDetails.vehicleModel}`;

		const formattedVehicleReg = this.vehicleDetails.vehicleReg.toUpperCase().replace(/^(.{4})(.{3})$/, '$1 $2');
		singleTripRegistration.textContent = formattedVehicleReg;

		singleTripFuelType.textContent = fuelTypeSelectedText;
		singleTripMilesTitle.textContent = `${distance} ${distanceText}`;

		singleTripPrice.textContent = `${this.fuelPrices.price}${this.cmsContent.fuelCostText}`;

		singleTripMPG.textContent = this.vehicleDetails.vehicleMPG;

		singleTripPostcodeFrom.textContent = this.formatPostcodeHelper(singleFormTripFrom.value);
		singleTripPostcodeTo.textContent = this.formatPostcodeHelper(singleFormTripTo.value);

		singleFormTripSearchBtn.classList.add('display-none');

		singleTripCost.textContent = price;

		singleResults.classList.remove('display-none');
	},

	handleSingleMileageCalculation: function (distance) {
		const price = this.annualMileageInstance.calculateAnnualResults(
			distance,
			this.pageElements.fuelCostInput.value
		);
		return sCurrencyFormatter(price);
	},

	singleTripDistanceCalculation: function (singleFormTripFrom, singleFormTripTo) {
		return new Promise((resolve, reject) => {
			const origin = singleFormTripFrom.value;
			const destination = singleFormTripTo.value;
			const metersToMiles = 0.000621371;
			const service = new google.maps.DistanceMatrixService();

			service.getDistanceMatrix(
				{
					origins: [origin],
					destinations: [destination],
					travelMode: 'DRIVING',
					unitSystem: google.maps.UnitSystem.IMPERIAL,
				},
				(response, status) => {
					if (status === 'OK' && response.rows[0].elements[0].status === 'OK') {
						const distance = Math.ceil(response.rows[0].elements[0].distance.value * metersToMiles);
						resolve(distance);
					} else {
						reject(status);
					}
				}
			);
		});
	},

	setUpRestartButton: function () {
		const resetConfig = resetCalculatorConfig({
			pageElements: fuelCostCalculator.pageElements,
		});

		const resetCalculator = new ResetCalculator(resetConfig);
		fuelCostCalculator.singleTripContent.restartButton.addEventListener('click', e => {
			e.preventDefault();
			resetCalculator.handleRestartPressed();
		});

		sBannerStep(1);
	},
};

document.addEventListener('DOMContentLoaded', function () {
	fuelCostCalculator.init();
});
